module.exports = require('./helpers/bundle-url').getBundleURL('lpdTb') + "logo.c51670a8.svg";